'use strict';exports.__esModule = true;exports.commodityOptionTypes = exports.initialCommodityValue = exports.MAX_ADVANTAGES = exports.MAX_COMMODITIES = exports.MAX_COMMODITY_TYPES = exports.AMOUNT_ROOMS = exports.PROJECT_FIELDS_NAMES = exports.PROJECT_LOGO_PICK = exports.PERFORMERS = exports.OPTIONS_STATUS = exports.PROJECT_MONTHS_OPTIONS = exports.LANGUAGES = undefined;var _helpers = require('./helpers');
var _publish = require('../../redux/modules/normalizers/publish');var _publish2 = _interopRequireDefault(_publish);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var LANGUAGES = exports.LANGUAGES = ['he', 'en', 'ru', 'fr'];

var PROJECT_MONTHS_OPTIONS = exports.PROJECT_MONTHS_OPTIONS = (0, _helpers.getMonthsOptions)();

var OPTIONS_STATUS = exports.OPTIONS_STATUS = ['planning', 'construction', 'handover'];

var PERFORMERS = exports.PERFORMERS = ['owner', 'contractor', 'architect'];

var PROJECT_LOGO_PICK = exports.PROJECT_LOGO_PICK = ['link', 'angle'];

var PROJECT_FIELDS_NAMES = exports.PROJECT_FIELDS_NAMES = {
  architect: 'architect',
  owner: 'owner',
  contractor: 'contractor',
  name_project: 'name_project',
  status: 'status',
  property_types: 'property_types',
  minimal_price: 'minimal_price',
  phone_number: 'phone_number',
  summary: 'summary',
  description: 'description',
  completion_date_months: 'completion_date_months',
  completion_date_years: 'completion_date_years',
  room_range: 'room_range',
  commodities: 'commodities',
  project_img: 'project_img',
  ownerImg: 'ownerImg',
  contractorImg: 'contractorImg',
  architectImg: 'architectImg',
  projectImages: 'projectImages',
  address: 'address',
  exact_price: 'exact_price',
  projectPerformers: 'projectPerformers',
  currency: 'currency',
  advantages: 'advantages',
  buildings: 'buildings',
  apartments: 'apartments',
  floors: 'floors' };


var AMOUNT_ROOMS = exports.AMOUNT_ROOMS = [
{
  id: 1,
  label: '1' },

{
  id: 2,
  label: '2' },

{
  id: 3,
  label: '3' },

{
  id: 4,
  label: '4' },

{
  id: 5,
  label: '5' },

{
  id: 6,
  label: '6' },

{
  id: 7,
  label: '7' },

{
  id: 8,
  label: '8' },

{
  id: 9,
  label: '9' },

{
  id: 10,
  label: '10+' }];



var MAX_COMMODITY_TYPES = exports.MAX_COMMODITY_TYPES = 4;
var MAX_COMMODITIES = exports.MAX_COMMODITIES = 10;
var MAX_ADVANTAGES = exports.MAX_ADVANTAGES = 6;


var initialCommodityValue = exports.initialCommodityValue = {
  type: '',
  items: [] };


var commodityOptionTypes = exports.commodityOptionTypes = {
  apartment: 'apartment',
  building: 'building',
  kitchen: 'kitchen',
  bathrooms: 'bathrooms',
  general: 'general',
  balcony: 'balcony',
  garden: 'garden',
  doors: 'doors',
  flooring: 'flooring',
  environment: 'environment',
  other: 'other' };


//////////////////
// WEBPACK FOOTER
// ./src/containers/PublishNewHomesForm/constants.js
// module id = 116
// module chunks = 0